module.exports = __webpack_public_path__ + "img/milan3.82372355.jpg";